import AuthLayout from '@/layouts/auth';
import LoginPage from '@/pages/Auth/Login';
import RegisterPage from '@/pages/Auth/Register';
import RegisterInfoPage from '@/pages/Auth/Info';

export default [
  {
    path: '/auth/login',
    component: LoginPage,
    name: 'auth.login',
    meta: {
      layout: AuthLayout,
    },
  },
  {
    path: '/auth/register',
    component: RegisterPage,
    name: 'auth.register',
    meta: {
      layout: AuthLayout,
    },
  },
  {
    path: '/auth/register/info',
    component: RegisterInfoPage,
    name: 'auth.register.info',
    meta: {
      layout: AuthLayout,
    },
  },
];
